import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const BookTimeSlotMutation = graphql(/* GraphQL */ `
  mutation bookTimeSlot($bookTimeSlotInput: BookTimeSlotInput!) {
    bookTimeSlot(input: $bookTimeSlotInput) {
      successOutput {
        ...SuccessOutput
      }
    }
  }
`);
